<template>
    <v-dialog v-model="dialogOpen" width="400">
        <v-card class="rounded-15 elevation-0">
            <v-card-title
                class="d-flex align-center justify-space-between text-blacknew"
            >
                <span class="font-weight-600 font-size-18">
                    Filter Paket Belajar
                </span>

                <v-btn icon variant="flat" small @click="$emit('close')">
                    <v-icon>mdi-close</v-icon>
                </v-btn>
            </v-card-title>

            <v-card-text class="px-4 pt-0 pb-3">
                <div class="font-weight-600 font-size-14 text-blacknew">
                    Pilih Fitur
                </div>

                <div class="mt-4">
                    <v-btn
                        v-for="(item, i) in filter_feature"
                        :key="i"
                        rounded="pill"
                        :color="
                            feature.includes(item.id) ? '#e1f4fc' : '#f0f3f9'
                        "
                        :class="
                            feature.includes(item.id)
                                ? 'text-blew'
                                : 'text-blacknew'
                        "
                        depressed
                        size="small"
                        class="mr-3 mb-3"
                        variant="flat"
                        height="32"
                        @click="toggleFeature(item.id)"
                    >
                        {{ item.text }}
                    </v-btn>
                </div>

                <div class="font-weight-600 font-size-14 text-blacknew mt-3">
                    Jenjang
                </div>

                <div class="d-flex gap-5 mt-2 mb-4">
                    <v-btn
                        v-for="(item, i) in filter_level"
                        :key="i"
                        rounded="pill"
                        :color="level === item.id ? '#e1f4fc' : '#f0f3f9'"
                        :class="
                            level === item.id ? 'text-blew' : 'text-blacknew'
                        "
                        depressed
                        size="small"
                        height="32"
                        variant="flat"
                        @click="level = level === item.id ? null : item.id"
                    >
                        {{ item.text }}
                    </v-btn>
                </div>

                <div v-show="level">
                    <div class="font-weight-600 font-size-14 text-blacknew">
                        Kelas
                    </div>

                    <div class="mt-2">
                        <v-btn
                            v-for="(item, i) in filter_grade"
                            :key="i"
                            rounded="pill"
                            :color="grade === item.id ? '#e1f4fc' : '#f0f3f9'"
                            :class="
                                grade === item.id
                                    ? 'text-blew'
                                    : 'text-blacknew'
                            "
                            class="mr-2 mb-3"
                            height="32"
                            depressed
                            size="small"
                            variant="flat"
                            @click="grade = grade === item.id ? null : item.id"
                        >
                            {{ item.text }}
                        </v-btn>
                    </div>
                </div>
            </v-card-text>

            <v-card-actions class="pa-3 pt-0">
                <v-btn
                    color="#0e97d6"
                    variant="flat"
                    rounded="pill"
                    block
                    @click="setFilter()"
                >
                    Terapkan
                </v-btn>
            </v-card-actions>
        </v-card>
    </v-dialog>
</template>

<script>
export default {
    props: {
        dialog: Boolean,
    },
    data() {
        return {
            dialogOpen: false,
            dialogFilterPackage: true,
            loading: false,
            feature: [],
            level: null,
            grade: null,
            featureStr: '',
            filter_feature: [
                {
                    id: 'analisa_snbp',
                    text: 'Analisa SNBP',
                },
                {
                    id: 'konsultasi',
                    text: 'Konsultasi',
                },
                {
                    id: 'tryout',
                    text: 'Tryout',
                },
                {
                    id: 'latihan_soal',
                    text: 'Latihan Soal',
                },
                {
                    id: 'modul_belajar',
                    text: 'Modul Belajar',
                },
                {
                    id: 'video_belajar',
                    text: 'Video Pembelajaran',
                },
                {
                    id: 'live_class',
                    text: 'Live Class',
                },
            ],
            filter_level: [
                {
                    id: 'sd',
                    text: 'SD',
                },
                {
                    id: 'smp',
                    text: 'SMP',
                },
                {
                    id: 'sma',
                    text: 'SMA',
                },
            ],
            filter_grade: [
                {
                    id: 10,
                    text: 'Kelas 10',
                },
                {
                    id: 11,
                    text: 'Kelas 11',
                },
                {
                    id: 12,
                    text: 'Kelas 12',
                },
                {
                    id: 13,
                    text: 'Alumni',
                },
            ],
        };
    },

    watch: {
        dialog(val) {
            this.dialogOpen = val;
        },

        level(val) {
            this.grade = null;

            if (val === 'sma') {
                this.filter_grade = [
                    {
                        id: 10,
                        text: 'Kelas 10',
                    },
                    {
                        id: 11,
                        text: 'Kelas 11',
                    },
                    {
                        id: 12,
                        text: 'Kelas 12',
                    },
                    {
                        id: 13,
                        text: 'Alumni',
                    },
                ];
            }

            if (val === 'smp') {
                this.filter_grade = [
                    {
                        id: 7,
                        text: 'Kelas 7',
                    },
                    {
                        id: 8,
                        text: 'Kelas 8',
                    },
                    {
                        id: 9,
                        text: 'Kelas 9',
                    },
                ];
            }

            if (val === 'sd') {
                this.filter_grade = [
                    {
                        id: 4,
                        text: 'Kelas 4',
                    },
                    {
                        id: 5,
                        text: 'Kelas 5',
                    },
                    {
                        id: 6,
                        text: 'Kelas 6',
                    },
                ];
            }
        },
    },

    methods: {
        toggleFeature(id) {
            if (this.feature.includes(id)) {
                this.feature = this.feature.filter((f) => f !== id);
            } else {
                this.feature.push(id);
            }

            const featureString =
                this.feature.length > 0 ? this.feature.join(',') : '';

            this.featureStr = featureString;
        },

        setFilter() {
            const filter = {
                feature: this.featureStr,
                level: this.level,
                grade: this.grade,
            };

            this.$emit('filter', filter);
        },
    },
};
</script>
